function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import ri from "./trigger-condition.js";

var ni = /*#__PURE__*/function () {
  function ni(t, i) {
    _classCallCheck(this, ni);

    this["if"] = t, this.rf = i, this["if"] = t, this.rf = i;
  }

  _createClass(ni, [{
    key: "xc",
    value: function xc(t) {
      if (null == this["if"]) return !1;
      var i = ri.sf(t[0], this["if"]);
      if (!i) return !1;
      var r = null == this.rf || 0 === this.rf.length;
      if (null != this.rf) for (var _i = 0; _i < this.rf.length; _i++) {
        if (this.rf[_i] === t[1]) {
          r = !0;
          break;
        }
      }
      return i && r;
    }
  }, {
    key: "Bs",
    value: function Bs() {
      return this["if"];
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ni(t ? t.id : null, t ? t.buttons : null);
    }
  }]);

  return ni;
}();

export { ni as default };